import React, { Component, useState } from 'react';
import { Col, Row } from 'reactstrap';
import axios from "axios";
import { Link } from "gatsby";
const config = require('../../data/siteConfig')

class priceOfPassport extends Component {
    constructor(props) {
        super(props);
        this.state = {
          costo:[],
          typeSeal:props.typeSeal,
          END_POINT:config.END_POINT
        }     
        this.getList();

    }
   

    getList() {

      const {costo, typeSeal ,END_POINT} = this.state
      let aux
        var headers = {
            'Content-Type': 'application/json' 
        }
        this.setState({
            serverState:{
            submitting: true
          }});
        axios({
          method: "GET",
          url: END_POINT+"stamp/all",
          headers: headers
        })
            .then(response => {
            
              if(typeSeal == "DNI_ED"){
                let typeSeals = ["DNI_ED","NEJ_MAY"];
                let costList=[];
                response.data.forEach(e => {
                    typeSeals.forEach( t =>{
                        if(e.code == t){
                            costList[t] = e.price
                        }
                    })                
                  });                  
                  this.setState({   
                    costo: costList
                  });
              }
              if(typeSeal == "DNI_PAS"){
                let typeSeals = ["PC_MAY","NEJ_MAY"];
                let totalCost=0;
                response.data.forEach(e => {
                    typeSeals.forEach( t =>{
                        if(e.code == t){
                            totalCost = totalCost + e.price
                        }
                    })                
                  });
                  this.setState({   
                    costo: totalCost
                  });
              }
              if(typeSeal != "DNI_ED" && typeSeal != "DNI_PAS"){
                response.data.forEach(e => {
                    if(e.code == typeSeal){
                      this.setState({
                        costo: e.price
                      });
                    }
                  });
              }              
          })
    }
    
    render() {
        const costo  = this.state.costo;
        const typeSeal  = this.state.typeSeal;

        if(typeSeal == 'PE_MAY'){
            return (            
                <Row className="mt-3 d-block">
                  <Col sm="12" md={{ size: 9 }}>
                    <p className= "ml-4 larger" >El valor de los trámites de Pasaporte Expres es de ${costo}.</p>
                  </Col>
                </Row>
            );
        }
        if(typeSeal == 'PC_MAY'){
            return (            
                <Row className="mt-3 d-block">
                  <Col sm="12" md={{ size: 9 }}>
                    <p className= "ml-4 larger" >El valor de todos los trámites de Pasaporte es de ${costo}.</p>
                  </Col>
                  <Col sm="12" md={{ size: 9 }}>
                    <p className= "ml-4 larger font-italic" >*El arancel no contempla el trámite de Pasaporte al Instante.</p>
                  </Col>
                </Row>
            );
        }
        if(typeSeal == 'DNI_EXP_MAY'){
            return (            
                <Row className="mt-3 d-block">
                  <Col sm="12" md={{ size: 9 }}>
                    <p className= "ml-4 larger" >El valor del trámite de DNI EXPRES es de ${costo}.</p>
                  </Col>
                </Row>
            );
        }
        if(typeSeal == 'DNI_ED'){
            return (            
                <Row className="mt-3 d-block">
                  <Col sm="12" md={{ size: 9 }}>
                    <p className= "ml-4 larger" >El valor de todos los trámites de DNI es de ${costo["NEJ_MAY"]}, a excepción del “DNI Primer ejemplar” que es gratuito.</p>
                  </Col>                  
                  <Col sm="12" md={{ size: 9 }}>
                    <p className= "ml-4 larger">A partir del Ejemplar D el precio del trámite varía a ${costo["DNI_ED"]}.</p>
                  </Col>
                </Row>
            );
        }
        if(typeSeal == 'DNI_PAS'){
            return (            
                <Row className="mt-3 d-block">
                  <Col sm="12" md={{ size: 9 }}>
                    <p className= "ml-4 larger" >El valor del trámite de DNI + Pasaporte es de ${costo}.</p>
                  </Col>                  
                  <Col sm="12" md={{ size: 9 }}>
                    <p className= "ml-4 larger">Podés abonar la combinación de DNI + Pasaporte.</p>
                  </Col>
                </Row>
            );
        }
    }
}

export default priceOfPassport;